import React, { lazy, Suspense } from "react";
import PantheonNetworkEmbedApp from "./PantheonNetworkEmbedApp";
import { isPantheonNetworkEmbedPath } from "./pantheonNetworkEmbedRoute";

const QuantumApplication = lazy(() => import("./QuantumApplication"));

export default function RootApplication({ pathname }) {
  const currentPath =
    pathname ?? (typeof window !== "undefined" ? window.location.pathname : "/");

  // The public embed is split before any Quantum provider mounts. This keeps
  // authentication, advertiser context, shell effects, and operational data
  // clients out of the embed runtime entirely.
  if (isPantheonNetworkEmbedPath(currentPath)) {
    return <PantheonNetworkEmbedApp />;
  }

  return (
    <Suspense fallback={null}>
      <QuantumApplication />
    </Suspense>
  );
}
